const UserType = {
  Agent: 'Agent',
  Agency: 'Agency',
  Consumer: 'Consumer',
} as const;

type UserType = (typeof UserType)[keyof typeof UserType];

export { UserType };
